import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getDocumentName } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { MyDataAction } from '../../forms/MyData';
import { UserTabs } from '../User';
import type { UserPaths } from '../User';
import type { UserPage_Tab_User_Fragment } from '../User/User';

import { MyAccountPage_OneUser_QueryDocument } from './queries/one-user.query';

interface Props {
  readonly user: FragmentType<typeof UserPage_Tab_User_Fragment>;
  readonly paths: UserPaths;
}

export const User = ({ user, paths }: Readonly<Props>) => {
  const queryClient = useQueryClient();

  const refetchUser = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: [getDocumentName(MyAccountPage_OneUser_QueryDocument)],
    });
  }, [queryClient]);

  return (
    <UserTabs
      accountActions={<MyDataAction onUpdated={refetchUser} />}
      paths={paths}
      user={user}
    />
  );
};
